import moment from 'moment'

export function formatDate(date: string) {
  const emptyDate = '1899-12-30'
  if (!date || date === emptyDate) return '-'
  return moment(date, moment.HTML5_FMT.DATE).format('L')
}
